import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    description:
      'Add your product or service and complete future invoices and quotes faster.',
    errorMessage:
      'An error has occurred. Please try again and if the problem persists, please contact us.',
    successMessage: 'Changes successfully saved!',
    title: 'Add an item',
  },
  fr: {
    cancel: 'Annuler',
    description:
      'Ajoutez votre produit ou service et remplissez vos futures factures et devis plus rapidement.',
    errorMessage:
      'Une erreur est survenue. Réessayez et si le problème persiste, contactez-nous.',
    successMessage: 'Modifications enregistrées avec succès !',
    title: 'Ajouter un article',
  },
} as const);
